export const NAME_SPACE = 'cashBalance'